import {
    JSONValue, prettyPrint,
} from 'utils/strings'

import Button from 'components/Button'
import {ClipBoardCopyIcon} from 'components/Icon'
import {CopyButtonProps} from '../types/copyButton'
import React from 'react'

import {styled} from 'stitches/config'
import {toast} from 'components/Toast'
import {useCopyToClipboard} from 'hooks/clipboard'
import {useTranslation} from 'react-i18next'

const StyledButtonContainer = styled('div', {})

export const CopyButton = (props: CopyButtonProps) => {
    const {
        currentKey, currentValue, showCopyAll,
    } = props
    const {t} = useTranslation()

    const clipboard = useCopyToClipboard({
        onSuccess: (copiedKey) => {
            if (copiedKey) {
                toast.success(t('Copied: {{key}}', {key: copiedKey}))
            } else {
                toast.success(t('Copied to clipboard'))
            }
        },
    })

    const handleCopy = (ev?: React.MouseEvent<HTMLButtonElement>) => {
        ev?.stopPropagation()

        if (typeof currentValue === 'object') {
            clipboard.copy(prettyPrint(currentValue as JSONValue), currentKey)
            return
        }

        clipboard.copy(currentValue, currentKey)
    }

    return (
        <StyledButtonContainer>
            <Button
                color='text'
                iconRight={ClipBoardCopyIcon}
                onPress={handleCopy}
                size='small'
                //  eslint-disable-next-line no-extra-parens
                text={(typeof currentValue === 'object' || showCopyAll) ? t('copy all') : undefined}
            />
        </StyledButtonContainer>
    )
}
